import {
  CurrencyFormatters,
  getRestrictedTravelCreditDescription,
} from "halifax";
import {
  StatementCreditDetail,
  TravelWalletCredit,
  TravelWalletOffer,
} from "redmond";

export const getTravelOfferBannerText = (
  offer: TravelWalletOffer,
  bannerType: "availability" | "shop"
) => {
  switch (bannerType) {
    case "availability":
      return offer.availabilityPageBanner;
    case "shop":
      return offer.shopPageBanner;
    default:
      return undefined;
  }
};

export const getTravelCreditBannerText = (
  credit: TravelWalletCredit,
  restrictedCreditDetail?: StatementCreditDetail
) => {
  if (restrictedCreditDetail) {
    const restrictedCreditDescription =
      getRestrictedTravelCreditDescription(restrictedCreditDetail) ||
      "travel credit";

    return `You have a <strong>$${Math.abs(
      restrictedCreditDetail.startingAmount.amount
    )} ${restrictedCreditDescription}</strong>. Eligible credits applied at checkout.`;
  }

  return `You have <strong>${CurrencyFormatters.add(
    credit.amount?.currency,
    undefined,
    "en-US"
  ).format(
    Math.abs(credit.amount?.amount || 0)
  )}</strong> in travel credits. Eligible credits applied at checkout.`;
};

export const MODAL_HOTELS_HEADER_TEXT =
  "<strong>Travel Offer</strong> | Save on Hotels";

export const SEARCH_HOTEL_CTA_COPY = "Search Hotel";

export const VIEW_OFFER_DETAILS_CTA_COPY = "View Offer Details";

export const VIEW_DETAILS_CTA_COPY = "View details";

export const CREDITS_MODAL_HEADER_TEXT = (name?: string) =>
  `${name ? `${name}'s ` : ""}<strong>travel credit</strong> summary`;
